import { Component } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder, FormControl } from '@angular/forms'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { select, Store } from '@ngrx/store'
import { userMessageNotificationMessages } from '@tv3/containers/automations/automations-wizard/message/messages'
import { selectAISettings } from '@tv3/containers/ai-responder/store/ai-settings.selectors'
import { DataCheckerService, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { UpdateAISettings } from '@tv3/containers/ai-responder/store/ai-settings.actions'
import { Subscribed } from '@tv3/shared/subscribed.decorator'
import { ProductsForPlan } from '@tv3/store/plan/plan.model'
import { AiResponderSettings } from '@tv3/containers/ai-responder/store/ai-settings.model'
import { AppOverviewDialogService } from '@tokeet-frontend/billing'
import { AISettingsGuard } from '@tv3/containers/ai-responder/store/ai-settings.guard'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-message-automation-wizard',
  templateUrl: './message-automation-wizard.component.html',
  styleUrls: ['./message-automation-wizard.component.scss'],
})
export class MessageAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Message

  userNotificationMessages = userMessageNotificationMessages

  aiDraftCtrl = this.fb.control(false)
  aiRespondCtrl = this.fb.control(false)

  constructor(
    private appOverview: AppOverviewDialogService, // this is for Subscribed decorator
    private dataChecker: DataCheckerService,
    protected fb: FormBuilder,
    protected actions: Actions,
    protected store: Store<any>
  ) {
    super(actions, store, fb)

    this.form.patchValue({ event: AutomationEventTypes.GuestMessageCreated })

    this.dataChecker.check([AISettingsGuard])
  }

  ngOnInit() {
    super.ngOnInit()

    this.store.pipe(select(selectAISettings), untilDestroy(this)).subscribe((settings) => {
      this.aiDraftCtrl.setValue(!!settings?.isCreateDrafts, { emitEvent: false })
      this.aiRespondCtrl.setValue(!!settings?.isAutomateSendReplies, { emitEvent: false })
    })

    const watchToggle = (ctrl: FormControl, cb: (checked: boolean) => void) => {
      ctrl.valueChanges.pipe(untilDestroy(this)).subscribe(cb)
    }

    watchToggle(this.aiDraftCtrl, (checked) => {
      this.doUpdate(
        { isCreateDrafts: checked },
        $localize`This feature is now ` + (checked ? $localize`enabled` : $localize`disabled`)
      )
    })

    watchToggle(this.aiRespondCtrl, (checked) => {
      this.doUpdate(
        { isAutomateSendReplies: checked },
        $localize`Automatically sending Advance Intelligence message option is ` +
          (checked ? $localize`enabled` : $localize`disabled`)
      )
    })
  }

  @Subscribed(ProductsForPlan.TokeetAI)
  doUpdate(payload: Partial<AiResponderSettings>, message: string) {
    this.store.dispatch(UpdateAISettings({ payload, message }))
  }

  getTooltip1(checked: boolean) {
    return checked
      ? $localize`Turn the toggle off if you don\'t want to generate AI based drafts`
      : $localize`Turn the toggle on if you want to generate AI based drafts`
  }

  getTooltip2(checked: boolean) {
    return checked
      ? $localize`Turn the toggle off if you don\'t want to send AI based response`
      : $localize`Turn the toggle on if you want to send AI based response`
  }
}
